import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  valves as valvesResource,
  valveGroups as valveGroupsResource,
} from '../../redux/actions/resource'
import {
  arrayFilter,
  getAllValves,
  getCurrentProjectId,
  getValveGroupById,
} from '../../redux/reducers'

import { Button } from '../../components/forms'
import Toolbar from '../../components/Toolbar'

import ValveList from './ValveList'

const AddValve = ({ history, match, t }) => {
  const valveGroupId = match.params.id
  const projectId = useSelector(getCurrentProjectId)
  const valveGroup = useSelector((state) =>
    getValveGroupById(state, valveGroupId)
  )
  const valveIds = valveGroup?.valveIds || []
  // filter out valves that are already part of the group
  const valves = useSelector((state) =>
    getAllValves(state, arrayFilter(valveIds, false))
  )
  const dispatch = useDispatch()
  const [selectedValveIds, setSelectedValveIds] = useState([])
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    dispatch(valveGroupsResource.read(valveGroupId))
    dispatch(valvesResource.list({ projectId }))
  }, [dispatch, projectId, valveGroupId])

  const onSearch = (search) => {
    dispatch(valvesResource.list({ projectId, search }))
  }

  const toggleValve = (id) => {
    setSelectedValveIds((ids) =>
      ids.includes(id)
        ? ids.filter((selectedId) => selectedId !== id)
        : [...ids, id]
    )
  }

  const addSelectedValves = () => {
    if (selectedValveIds.length === 0 || submitting) {
      return
    }

    setSubmitting(true)
    dispatch(
      valveGroupsResource.update(valveGroupId, undefined, {
        valveGroup: {
          valveIds: [...new Set([...valveIds, ...selectedValveIds])],
        },
      })
    ).promise.then((result) => {
      if (result instanceof Error) {
        setSubmitting(false)
      } else {
        history.push(`/valve_groups/${valveGroupId}`)
      }
    })
  }

  return (
    <>
      <Toolbar title="Ventilauswahl" />
      <ValveList
        valves={valves}
        onSearch={onSearch}
        onTileClick={toggleValve}
        selectedIds={selectedValveIds}
        toolbarActions={
          <Button
            autoSize
            disabled={selectedValveIds.length === 0 || submitting}
            waiting={submitting}
            onClick={addSelectedValves}
          >
            {t('addSelectedValves', { count: selectedValveIds.length })}
          </Button>
        }
      >
        {() => null}
      </ValveList>
    </>
  )
}

export default withRouter(withTranslation()(AddValve))
